import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';

@Injectable()
export class SystemActionCategoryService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public findByName(name: string): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byName/${name}`
    );
  }

  public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...pagination,
    };

    return this.httpClient.post<any[]>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    );
  }
}
